
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/use-case/stickey-wallet",
      function () {
        return require("private-next-pages/use-case/stickey-wallet.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/use-case/stickey-wallet"])
      });
    }
  